export const EVENTS = {
	// Phaser -> React
	ANSWER: 'answer',
	FINISH: 'finish',
	CLOSE: 'close',
	STATE_CHANGE: 'stateChange',
	SCENE_READY: 'sceneReady',

	// React -> Phaser
	LOAD_GAME: 'loadGame',
	START_GAME: 'startGame',
	SET_AUDIO_ON: 'setAudioOn',
	CANCEL_GAME: 'cancelGame',
	RETURN_TO_START: 'returnToStart',
	INPUT_DIGIT: 'inputDigit',
} as const;
